import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type GlobalSearchAndLibraryConfigFragment = { globalSearch?: { allowedContentTypes?: Array<Types.SearchableContentTypeEnum> | null } | null, library?: { allowedContentTypes?: Array<Types.SearchableContentTypeEnum> | null, additionalFilters?: Array<Types.GlobalSearchAndLibraryFilterTypeEnum> | null, featuredTagIds?: Array<string> | null } | null };


export type GlobalSearchAndLibraryConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const GlobalSearchAndLibraryConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment GlobalSearchAndLibraryConfig on GlobalSearchAndLibraryConfigType {
  globalSearch {
    allowedContentTypes
  }
  library {
    allowedContentTypes
    additionalFilters
    featuredTagIds
  }
}
    `;